import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, { mode: "out-in" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, {
              include: _ctx.cachedViews,
              max: 10
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.name || route.path
              }))
            ], 1032, ["include"]))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}